/**
 * Parses an NDJSON (Newline Delimited JSON) stream into individual JSON objects.
 * Returns an async generator that yields parsed objects one by one.
 */
export async function* parseNDJSON<T = any>(
  stream: ReadableStream<Uint8Array>,
): AsyncGenerator<T, void, unknown> {
  const reader = stream.getReader()
  const decoder = new TextDecoder()
  let buffer = ""

  try {
    while (true) {
      const { value, done } = await reader.read()
      if (done) break

      buffer += decoder.decode(value, { stream: true })
      const lines = buffer.split("\n")
      buffer = lines.pop() ?? ""

      for (const line of lines) {
        if (line.trim()) {
          yield JSON.parse(line) as T
        }
      }
    }
  } finally {
    reader.releaseLock?.()
  }

  // Handle any remaining buffered data
  if (buffer.trim()) {
    yield JSON.parse(buffer) as T
  }
}
